module.exports = __webpack_public_path__ + "img/09.ad69a884.jpg";